import { DocumentToolbarMode } from '../enums/document-toolbar-mode';

export class OrderSettings {
  public useListPreview = true;
  public showProjectDescription = true;
  public openOrderInNewTab = false;
  public allowNewTabOnIconClick = false;
  public documentToolbarMode: DocumentToolbarMode = DocumentToolbarMode.Default;

  public setDocumentToolbarByName(name: string) {
    if (name == null || name == '') {
      return;
    }
    name = name.toLowerCase();
    if (name == 'default') {
      this.documentToolbarMode = DocumentToolbarMode.Default;
    } else if (name == 'small') {
      this.documentToolbarMode = DocumentToolbarMode.Small;
    }
  }
}
